//settings
import React, { useState, useEffect } from "react";

//styles
import StylesPortolio from "./portfolio.module.scss";
import StylesGeneral from "../../structure_styles/general-styles.module.scss";

//icons
import {
        FaCode,FaReact, FaJs, FaPhp, FaCss3Alt, FaNodeJs, FaBootstrap,
        FaSass, FaAngular, FaHtml5
    } from "react-icons/fa";
import { SiMysql, SiTypescript, SiJquery, SiPhpmyadmin, SiAxios } from "react-icons/si";
import { TbBrandCSharp } from "react-icons/tb";

//assets
import marvel from "../../assets/apps_images/marvel.png";
import checkInApp from "../../assets/apps_images/checkIn.png";
import solarSystemApp from "../../assets/apps_images/solarsystem.png";
import labReact from "../../assets/apps_images/labReact.png";
import cherti from "../../assets/apps_images/cherti.png";
import labC from "../../assets/apps_images/labC.jpeg";
import hospital from "../../assets/apps_images/hospital.png";
import fixSystem from "../../assets/apps_images/fixSystem.jpeg";
import afiliates from "../../assets/apps_images/afiliates.png";
import store from "../../assets/apps_images/store.png";


const PortfolioView: React.FC = () => {

    const [showPortfolio, setShowPortfolio] = useState(0);

    return (
        <>
            <div className={[StylesPortolio.__main_portfolio_container].join(' ')}>
                <div className={[StylesPortolio.__show_portfolio].join(' ')}>
                    <div className={[StylesPortolio.__head_view].join(' ')}>
                        <div className={[StylesPortolio.__title].join(' ')}>
                            Portafolio
                        </div>
                        <div className={[StylesPortolio.__description].join(' ')}>
                            Contactame para conocer mas a profundidad mis proyectos
                        </div>
                        <div className={[StylesPortolio.__buttons_apps].join(' ')}>
                            <div className={[StylesPortolio.__app_name].join(' ')} onClick={()=>setShowPortfolio(0)}>
                                Sistema solar
                            </div>
                            <div className={[StylesPortolio.__app_name].join(' ')} onClick={()=>setShowPortfolio(1)}>
                                Laboratorio escolar
                            </div>
                            <div className={[StylesPortolio.__app_name].join(' ')} onClick={()=>setShowPortfolio(2)}>
                                Cherti
                            </div>
                            <div className={[StylesPortolio.__app_name].join(' ')} onClick={()=>setShowPortfolio(3)}>
                                Sistema hospitalario
                            </div>
                            <div className={[StylesPortolio.__app_name].join(' ')} onClick={()=>setShowPortfolio(4)}>
                                Marvel
                            </div>
                            <div className={[StylesPortolio.__app_name].join(' ')} onClick={()=>setShowPortfolio(5)}>
                                CheckIn
                            </div>
                            <div className={[StylesPortolio.__app_name].join(' ')} onClick={()=>setShowPortfolio(6)}>
                                Sistema para laboratorista
                            </div>
                            <div className={[StylesPortolio.__app_name].join(' ')} onClick={()=>setShowPortfolio(7)}>
                                Sistema de reparaciones
                            </div>
                            <div className={[StylesPortolio.__app_name].join(' ')} onClick={()=>setShowPortfolio(8)}>
                                Sistema de afiliados
                            </div>
                            <div className={[StylesPortolio.__app_name].join(' ')} onClick={()=>setShowPortfolio(9)}>
                                Tienda en linea
                            </div>
                        </div>
                    </div>

                    <div className={[StylesPortolio.__show_apps].join(' ')}>
                        {showPortfolio === 0 &&
                            <>
                                <div className={[StylesPortolio.__main_div_app].join(' ')}>
                                    <div className={[StylesPortolio.__title_div].join(' ')}>
                                        <div className={[StylesPortolio.__name].join(' ')}>
                                            Simulacion de Sistema Solar
                                        </div>
                                        <div className={[StylesPortolio.__date].join(' ')}>
                                            Septiembre 2024
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__image_div].join(' ')}>
                                        <div className={[StylesPortolio.__img].join(' ')}>
                                            <img src={solarSystemApp} alt="img_app" />
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__tech_div].join(' ')}>
                                        <div className={[StylesPortolio.__text].join(' ')}>
                                            Tecnologías
                                        </div>
                                        <div className={[StylesPortolio.__tech_icons].join(' ')}>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaReact />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <SiTypescript />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaSass />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__description_div].join(' ')}>
                                        <div className={[StylesPortolio.__title].join(' ')}>
                                            Descripción
                                        </div>
                                        <div className={[StylesPortolio.__description].join(' ')}>
                                            Sistema Solar simulación es una aplicación WEB, la cual simula la órbita de los planetas base del sistema solar, 
                                            además de mostrar información básica de cada planeta (tamaño, distancia, etc.). 
                                            También se puede configurar para controlar la cantidad de estrellas de fondo y su velocidad de movimiento
                                        </div>
                                    </div>
                                </div>
                            </>
                        }

                        {showPortfolio === 1 &&
                            <>
                                <div className={[StylesPortolio.__main_div_app].join(' ')}>
                                    <div className={[StylesPortolio.__title_div].join(' ')}>
                                        <div className={[StylesPortolio.__name].join(' ')}>
                                            Laboratorio escolar
                                        </div>
                                        <div className={[StylesPortolio.__date].join(' ')}>
                                            Octubre 2024
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__image_div].join(' ')}>
                                        <div className={[StylesPortolio.__img].join(' ')}>
                                            <img src={labReact} alt="img_app" />
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__tech_div].join(' ')}>
                                        <div className={[StylesPortolio.__text].join(' ')}>
                                            Tecnologías
                                        </div>
                                        <div className={[StylesPortolio.__tech_icons].join(' ')}>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaReact />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <SiTypescript />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <SiAxios />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaNodeJs />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaSass />
                                            </div>
                                            <div className={[StylesPortolio.__icon, StylesPortolio.__icon_small].join(' ')}>
                                                <SiMysql />
                                            </div>
                                            <div className={[StylesPortolio.__icon, StylesPortolio.__icon_small].join(' ')}>
                                                <SiPhpmyadmin />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__description_div].join(' ')}>
                                        <div className={[StylesPortolio.__title].join(' ')}>
                                            Descripción
                                        </div>
                                        <div className={[StylesPortolio.__description].join(' ')}>
                                            Laboratorio escolar es una aplicación WEB, la cual ayuda a escuelas a administrar tareas en sus laboratorios, 
                                            esta aplicación consta de 3 roles base: <br /><br />
                                            Usuario tipo administrador: con el cual se pueden dar de alta los laboratorios, 
                                            agregar usuarios y configurar historial. <br /><br />
                                            Usuario tipo laboratorista: con el cual se pueden administrar las prácticas en calendarios semanales, 
                                            administrar inventarios y reportar material roto. <br /><br />
                                            Usuario tipo practicante: este rol es para los estudiantes que 
                                            desean hacer su servicio dentro de un laboratorio escolar, con el cual pueden ver el calendario de prácticas, 
                                            para preparar lo necesario en las prácticas programadas.
                                        </div>
                                    </div>
                                </div>
                            </>
                        }

                        {showPortfolio === 2 &&
                            <>
                                <div className={[StylesPortolio.__main_div_app].join(' ')}>
                                    <div className={[StylesPortolio.__title_div].join(' ')}>
                                        <div className={[StylesPortolio.__name].join(' ')}>
                                            CherTi
                                        </div>
                                        <div className={[StylesPortolio.__date].join(' ')}>
                                            Abril 2022
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__image_div].join(' ')}>
                                        <div className={[StylesPortolio.__img].join(' ')}>
                                            <img src={cherti} alt="img_app" />
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__tech_div].join(' ')}>
                                        <div className={[StylesPortolio.__text].join(' ')}>
                                            Tecnologías
                                        </div>
                                        <div className={[StylesPortolio.__tech_icons].join(' ')}>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaHtml5 />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaCss3Alt />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaBootstrap />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaJs />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <span>AJAX</span>
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <SiJquery />
                                            </div>
                                            <div className={[StylesPortolio.__icon, StylesPortolio.__icon_small].join(' ')}>
                                                <FaPhp />
                                            </div>
                                            <div className={[StylesPortolio.__icon, StylesPortolio.__icon_small].join(' ')}>
                                                <SiMysql />
                                            </div>
                                            <div className={[StylesPortolio.__icon, StylesPortolio.__icon_small].join(' ')}>
                                                <SiPhpmyadmin />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__description_div].join(' ')}>
                                        <div className={[StylesPortolio.__title].join(' ')}>
                                            Descripción
                                        </div>
                                        <div className={[StylesPortolio.__description].join(' ')}>
                                            Cherti es una aplicación WEB, en donde dueños de propiedades pueden ponerlas en renta, y mediante filtrados, coordenadas y 
                                            mapas los clientes pueden buscar la mejor opción para hacer contratos en arrendamientos con los renteros.
                                            Cherti consta de 3 tipos de roles de usuario:<br /><br />
                                            Usuario tipo administrador: este usuario es el encargado de administrar la aplicación, puede dar de baja usuarios, 
                                            recibe reportes de usuarios, comentarios de la aplicación y válida los documentos al dar de alta una nueva propiedad.<br /><br />
                                            Usuario tipo rentero: este usuario es el dueño de las propiedades, el cual mediante un dashboard, puede ver 
                                            Estadísticas de ganancias, así mismo recibe las solicitudes de clientes para rentar una de sus propiedades.<br /><br />
                                            Usuario tipo cliente: este usuario puede buscar su casa ideal, mediante filtros que más le convengan, 
                                            y puede mantener conversaciones con su rentero, además de opinar y calificar el servicio de la casa y del rentero.
                                        </div>
                                    </div>
                                </div>
                            </>
                        }

                        {showPortfolio === 3 &&
                            <>
                                <div className={[StylesPortolio.__main_div_app].join(' ')}>
                                    <div className={[StylesPortolio.__title_div].join(' ')}>
                                        <div className={[StylesPortolio.__name].join(' ')}>
                                            Sistema hospitalario
                                        </div>
                                        <div className={[StylesPortolio.__date].join(' ')}>
                                            Enero 2022
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__image_div].join(' ')}>
                                        <div className={[StylesPortolio.__img].join(' ')}>
                                            <img src={hospital} alt="img_app" />
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__tech_div].join(' ')}>
                                        <div className={[StylesPortolio.__text].join(' ')}>
                                            Tecnologías
                                        </div>
                                        <div className={[StylesPortolio.__tech_icons].join(' ')}>
                                             <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaHtml5 />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaCss3Alt />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaBootstrap />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaJs />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <span>AJAX</span>
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <SiJquery />
                                            </div>
                                            <div className={[StylesPortolio.__icon, StylesPortolio.__icon_small].join(' ')}>
                                                <FaPhp />
                                            </div>
                                            <div className={[StylesPortolio.__icon, StylesPortolio.__icon_small].join(' ')}>
                                                <SiMysql />
                                            </div>
                                            <div className={[StylesPortolio.__icon, StylesPortolio.__icon_small].join(' ')}>
                                                <SiPhpmyadmin />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__description_div].join(' ')}>
                                        <div className={[StylesPortolio.__title].join(' ')}>
                                            Descripción
                                        </div>
                                        <div className={[StylesPortolio.__description].join(' ')}>
                                            Este sistema es una aplicación WEB, en la cual apoya a hospitales en sus tareas administrativas y de gestión.
                                            Esta aplicación consta de 4 tipos usuarios:<br /><br />
                                            Usuario tipo administrador: Este usuario tiene el control de la caja principal y de administrar el resto de usuarios,
                                            además de ver mediante historial todos los movimientos hechos dentro del sistema.<br /><br />
                                            Usuario tipo doctor: Este usuario puede ver los registros de citas programadas y de urgencia, además de poder realizar 
                                            una receta para poder generar un PDF para su posterior impresión.<br /><br />
                                            Usuario tipo recepción: Este usuario se encarga de registrar nuevas entradas y programar citas con el doctor, además 
                                            de poder administrar una de las cajas de cobro en citas.<br /><br />
                                            Usuario tipo farmacia: Este usuario es el encargado de la farmacia del hospital, puede administrar inventarios y vender 
                                            medicinas, así mismo dispone de la función de caja para tener un control de ventas de productos.
                                        </div>
                                    </div>
                                </div>
                            </>
                        }

                        {showPortfolio === 4 &&
                            <>
                                <div className={[StylesPortolio.__main_div_app].join(' ')}>
                                    <div className={[StylesPortolio.__title_div].join(' ')}>
                                        <div className={[StylesPortolio.__name].join(' ')}>
                                            Marvel
                                        </div>
                                        <div className={[StylesPortolio.__date].join(' ')}>
                                            Octubre 2024
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__image_div].join(' ')}>
                                        <div className={[StylesPortolio.__img].join(' ')}>
                                            <img src={marvel} alt="img_app" />
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__tech_div].join(' ')}>
                                        <div className={[StylesPortolio.__text].join(' ')}>
                                            Tecnologías
                                        </div>
                                        <div className={[StylesPortolio.__tech_icons].join(' ')}>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaReact />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <SiTypescript />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <SiAxios />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaSass />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__description_div].join(' ')}>
                                        <div className={[StylesPortolio.__title].join(' ')}>
                                            Descripción
                                        </div>
                                        <div className={[StylesPortolio.__description].join(' ')}>
                                            Marvel es una aplicación WEB, la cual sirve para ver todos los héroes registrados dentro de la API hecha por Marvel
                                        </div>
                                    </div>
                                </div>
                            </>
                        }

                        {showPortfolio === 5 &&
                            <>
                                <div className={[StylesPortolio.__main_div_app].join(' ')}>
                                    <div className={[StylesPortolio.__title_div].join(' ')}>
                                        <div className={[StylesPortolio.__name].join(' ')}>
                                            Sistema de entradas y salidas
                                        </div>
                                        <div className={[StylesPortolio.__date].join(' ')}>
                                            Octubre 2024
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__image_div].join(' ')}>
                                        <div className={[StylesPortolio.__img].join(' ')}>
                                            <img src={checkInApp} alt="img_app" />
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__tech_div].join(' ')}>
                                        <div className={[StylesPortolio.__text].join(' ')}>
                                            Tecnologías
                                        </div>
                                        <div className={[StylesPortolio.__tech_icons].join(' ')}>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaAngular />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <SiTypescript />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaNodeJs />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <SiAxios />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaSass />
                                            </div>
                                            <div className={[StylesPortolio.__icon, StylesPortolio.__icon_small].join(' ')}>
                                                <SiMysql />
                                            </div>
                                            <div className={[StylesPortolio.__icon, StylesPortolio.__icon_small].join(' ')}>
                                                <SiPhpmyadmin />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__description_div].join(' ')}>
                                        <div className={[StylesPortolio.__title].join(' ')}>
                                            Descripción
                                        </div>
                                        <div className={[StylesPortolio.__description].join(' ')}>
                                            Sistema de entradas y salidas es una aplicación WEB, cuya función es registrar y administrar las entradas y salidas, 
                                            de los empleados de una organización, aquí el administrador puede fijar horarios de entrada y salida, 
                                            para cada empleado de tal manera que podrá facilitar calcular el % de puntualidad de cada usuario.
                                        </div>
                                    </div>
                                </div>
                            </>
                        }

                        {showPortfolio === 6 &&
                            <>
                                <div className={[StylesPortolio.__main_div_app].join(' ')}>
                                    <div className={[StylesPortolio.__title_div].join(' ')}>
                                        <div className={[StylesPortolio.__name].join(' ')}>
                                            Sistema para laboratorista
                                        </div>
                                        <div className={[StylesPortolio.__date].join(' ')}>
                                            Febrero 2022 2024
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__image_div].join(' ')}>
                                        <div className={[StylesPortolio.__img].join(' ')}>
                                            <img src={labC} alt="img_app" />
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__tech_div].join(' ')}>
                                        <div className={[StylesPortolio.__text].join(' ')}>
                                            Tecnologías
                                        </div>
                                        <div className={[StylesPortolio.__tech_icons].join(' ')}>
                                            <div className={[StylesPortolio.__icon, StylesPortolio.__icon_small].join(' ')}>
                                                <TbBrandCSharp />
                                            </div>
                                            <div className={[StylesPortolio.__icon, StylesPortolio.__icon_small].join(' ')}>
                                                <SiMysql />
                                            </div>
                                            <div className={[StylesPortolio.__icon, StylesPortolio.__icon_small].join(' ')}>
                                                <SiPhpmyadmin />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__description_div].join(' ')}>
                                        <div className={[StylesPortolio.__title].join(' ')}>
                                            Descripción
                                        </div>
                                        <div className={[StylesPortolio.__description].join(' ')}>
                                            Laboratorio Escolar es una aplicación de escritorio, la cual sirve para que un laboratorista escolar
                                            pueda llevar la gestión de laboratorios desde su computadora, esta aplicación está diseñada 
                                            para brindar soporte discreto al laboratorista.
                                        </div>
                                    </div>
                                </div>
                            </>
                        }

                        {showPortfolio === 7 &&
                            <>
                                <div className={[StylesPortolio.__main_div_app].join(' ')}>
                                    <div className={[StylesPortolio.__title_div].join(' ')}>
                                        <div className={[StylesPortolio.__name].join(' ')}>
                                            Sistema de reparaciones
                                        </div>
                                        <div className={[StylesPortolio.__date].join(' ')}>
                                            Diciembre 2021
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__image_div].join(' ')}>
                                        <div className={[StylesPortolio.__img].join(' ')}>
                                            <img src={fixSystem} alt="img_app" />
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__tech_div].join(' ')}>
                                        <div className={[StylesPortolio.__text].join(' ')}>
                                            Tecnologías
                                        </div>
                                        <div className={[StylesPortolio.__tech_icons].join(' ')}>
                                            <div className={[StylesPortolio.__icon, StylesPortolio.__icon_small].join(' ')}>
                                                <TbBrandCSharp />
                                            </div>
                                            <div className={[StylesPortolio.__icon, StylesPortolio.__icon_small].join(' ')}>
                                                <SiMysql />
                                            </div>
                                            <div className={[StylesPortolio.__icon, StylesPortolio.__icon_small].join(' ')}>
                                                <SiPhpmyadmin />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__description_div].join(' ')}>
                                        <div className={[StylesPortolio.__title].join(' ')}>
                                            Descripción
                                        </div>
                                        <div className={[StylesPortolio.__description].join(' ')}>
                                            Sistema de reparaciones es una aplicación de escritorio, la cual apoya a pequeños establecimientos 
                                            de arreglo de dispositivos electrónicos, esta aplicación consta 2 tipos de usuarios:<br /><br />
                                            Usuario tipo administrador: este usuario puede administrar entradas y salidas de dispositivos, además de 
                                            llevar la administración de usuarios, inventario, caja e historial de movimientos.<br /><br />
                                            Usuario tipo empleado: este usuario únicamente puede ver, agregar y entregar los trabajos pendientes.
                                        </div>
                                    </div>
                                </div>
                            </>
                        }

                        {showPortfolio === 8 &&
                            <>
                                <div className={[StylesPortolio.__main_div_app].join(' ')}>
                                    <div className={[StylesPortolio.__title_div].join(' ')}>
                                        <div className={[StylesPortolio.__name].join(' ')}>
                                            Sistema de afiliados
                                        </div>
                                        <div className={[StylesPortolio.__date].join(' ')}>
                                            Noviembre 2021
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__image_div].join(' ')}>
                                        <div className={[StylesPortolio.__img].join(' ')}>
                                            <img src={afiliates} alt="img_app" />
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__tech_div].join(' ')}>
                                        <div className={[StylesPortolio.__text].join(' ')}>
                                            Tecnologías
                                        </div>
                                        <div className={[StylesPortolio.__tech_icons].join(' ')}>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaHtml5 />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaCss3Alt />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaBootstrap />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaJs />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <span>AJAX</span>
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <SiJquery />
                                            </div>
                                            <div className={[StylesPortolio.__icon, StylesPortolio.__icon_small].join(' ')}>
                                                <FaPhp />
                                            </div>
                                            <div className={[StylesPortolio.__icon, StylesPortolio.__icon_small].join(' ')}>
                                                <SiMysql />
                                            </div>
                                            <div className={[StylesPortolio.__icon, StylesPortolio.__icon_small].join(' ')}>
                                                <SiPhpmyadmin />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__description_div].join(' ')}>
                                        <div className={[StylesPortolio.__title].join(' ')}>
                                            Descripción
                                        </div>
                                        <div className={[StylesPortolio.__description].join(' ')}>
                                            Sistema de afiliados es una aplicación WEB, la cual ayuda a los partidos políticos a administrar y gestionar 
                                            sus afiliados y simpatizantes. Esta aplicación consta de 3 usuarios, que tienen las mismas funcionalidades como 
                                            administrar usuarios, registros, historial, ver avances gráficamente y en mapas, etc. pero cada usuario 
                                            enfocado a su región, los usuarios son: Administrador nacional, Administrador estatal y Administrador distrital,
                                        </div>
                                    </div>
                                </div>
                            </>
                        }

                        {showPortfolio === 9 &&
                            <>
                                <div className={[StylesPortolio.__main_div_app].join(' ')}>
                                    <div className={[StylesPortolio.__title_div].join(' ')}>
                                        <div className={[StylesPortolio.__name].join(' ')}>
                                            Tienda en Linea
                                        </div>
                                        <div className={[StylesPortolio.__date].join(' ')}>
                                            Octubre 2021
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__image_div].join(' ')}>
                                        <div className={[StylesPortolio.__img].join(' ')}>
                                            <img src={store} alt="img_app" />
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__tech_div].join(' ')}>
                                        <div className={[StylesPortolio.__text].join(' ')}>
                                            Tecnologías
                                        </div>
                                        <div className={[StylesPortolio.__tech_icons].join(' ')}>
                                             <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaHtml5 />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaCss3Alt />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaBootstrap />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <FaJs />
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <span>AJAX</span>
                                            </div>
                                            <div className={[StylesPortolio.__icon].join(' ')}>
                                                <SiJquery />
                                            </div>
                                            <div className={[StylesPortolio.__icon, StylesPortolio.__icon_small].join(' ')}>
                                                <FaPhp />
                                            </div>
                                            <div className={[StylesPortolio.__icon, StylesPortolio.__icon_small].join(' ')}>
                                                <SiMysql />
                                            </div>
                                            <div className={[StylesPortolio.__icon, StylesPortolio.__icon_small].join(' ')}>
                                                <SiPhpmyadmin />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={[StylesPortolio.__description_div].join(' ')}>
                                        <div className={[StylesPortolio.__title].join(' ')}>
                                            Descripción
                                        </div>
                                        <div className={[StylesPortolio.__description].join(' ')}>
                                            Tienda en línea es una aplicación WEB, la cual ayuda a comerciantes a publicar sus productos en línea, y a su vez 
                                            administrar sus ventas de manera más eficaz. Esta aplicación consta de 2 tipos de usuario:<br /><br />
                                            Usuario tipo administrador: es el dueño del negocio, el cual puede administrar sus productos, clientes y ventas 
                                            mediante un dashboard.<br /><br />
                                            Usuario tipo cliente: este usuario puede ver, opinar y calificar productos, administrar direcciones de entrega, puede 
                                            ver su historial de compras e imprimir tickets formato PDF y enviar mensajes directos al administrador.
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                       
                    </div>
                    
                </div>
            </div>
        </>
    );
}

export default PortfolioView;